module.exports = __webpack_public_path__ + "img/mc-repeat.d8079a81.svg";